function RadioSwitch({ state, setter, id }) {
  return (
    <fieldset className="flex gap-12 mt-6">
      <legend className="sr-only">Send By</legend>
      <div className="flex items-center mb-4">
        <input
          id="sms"
          type="radio"
          name={state.toString()}
          onChange={setter}
          defaultValue="SMS"
          className="w-4 h-4 border-gray-300 focus:outline-none"
          defaultChecked
        />
        <label
          htmlFor="sms"
          className="block ml-2 text-sm font-medium text-gray-400"
        >
          SMS
        </label>
      </div>
      <div className="flex items-center mb-4">
        <input
          id="email"
          type="radio"
          name={state.toString()}
          onChange={setter}
          defaultValue="EMAIL"
          className="w-4 h-4 border-gray-300 focus:outline-none"
        />
        <label
          htmlFor="email"
          className="block ml-2 text-sm font-medium text-gray-400"
        >
          EMAIL
        </label>
      </div>
    </fieldset>
  );
}

export default RadioSwitch;
